(function ($) {
    $(function () {

        var accordionBlocks = $('.accordion-block');

        if (accordionBlocks.length < 1) {
            return;
        }

        // Hide all accordion items
        $('.accordion-block__accordion-item__content').addClass('accordion-block__accordion-item__content--hidden');

        accordionBlocks.each(function () {

            // Define accordion items
            var accordionItems = $(this).children('.accordion-block__accordion-item');

            accordionItems.each(function () {
                // Append icons
                var iconWrapper = $(this).find('.accordion-block__accordion-item__title__icon');

                iconWrapper.append('<span class="accordion-toggle"></span>');

                // Make it work
                var title = $(this).find('.accordion-block__accordion-item__title');
                var content = $(this).find('.accordion-block__accordion-item__content');
                var icon = $(this).find('.accordion-toggle');

                title.on('click', function (e) {

                    // Prevent the default action
                    e.preventDefault();

                    // Close them all first!
                    accordionItems.find('.accordion-block__accordion-item__content').not(content).slideUp();
                    accordionItems.find('.accordion-block__accordion-item__title__icon .accordion-toggle').not(icon).removeClass('accordion-toggle--active');
                    accordionItems.find('.accordion-block__accordion-item__title').not($(this)).removeClass('active');

                    // Open the current one
                    $(this).toggleClass('active');
                    if ($(this).hasClass('active')) {
                        content.slideDown();
                        icon.addClass('accordion-toggle--active');
                    } else {
                        content.slideUp();
                        icon.removeClass('accordion-toggle--active');
                    }
                });
            });

        });

    });
})(jQuery);